import axios from 'axios'
import urls from '../../configs/urls'

const instance = axios.create({
    baseURL: urls.api,
    withCredentials: true
  });

export default instance


// WEBPACK FOOTER //
// ./src/store/http/axios.js